import { EWalletId } from '@ankr.com/provider';

import binanceIcon from 'assets/binance.svg';
import huobiIcon from 'assets/huobi.svg';
import imTokenIcon from 'assets/im_token.svg';
import mathWalletIcon from 'assets/math_wallet.svg';
import metaMaskIcon from 'assets/metamask.svg';
import trustWalletIcon from 'assets/trust_wallet.svg';
import walletConnectIcon from 'assets/wallet_connect.svg';

export function getWalletIcon(walletId: EWalletId): string | null {
  switch (walletId) {
    case EWalletId.injected:
      return metaMaskIcon;
    case EWalletId.binanceWallet:
      return binanceIcon;
    case EWalletId.huobi:
      return huobiIcon;
    case EWalletId.imtoken:
      return imTokenIcon;
    case EWalletId.math:
      return mathWalletIcon;
    case EWalletId.trust:
      return trustWalletIcon;
    case EWalletId.walletconnect:
      return walletConnectIcon;
    default:
      return null;
  }
}
